
/* Segmented Insurance / Roadside toggle for the RentShield carousel. Rendered inside each
   card's card-wide <a>, so it uses role="tab" spans (not <button>s) to avoid nesting
   interactive elements, and stops propagation so switching slides never follows the card link. */
const OPTIONS = ["Insurance", "Roadside"];
export function CardSlideToggle({ active, onSelect, }) {
    return (<div role="tablist" aria-label="Switch RentShield coverage" className="inline-flex items-center gap-1 rounded-full border border-white/20 bg-black/30 p-1 backdrop-blur-md">
      {OPTIONS.map((label, i) => {
            const select = (e) => {
                e.preventDefault();
                e.stopPropagation();
                onSelect(i);
            };
            return (<span key={label} role="tab" tabIndex={0} aria-selected={active === i} onClick={select} onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ")
                        select(e);
                }} className={`cursor-pointer select-none rounded-full px-4 py-1.5 font-sans text-sm font-medium transition-colors ${active === i ? "bg-white text-black" : "text-white/70 hover:text-white"}`}>
            {label}
          </span>);
        })}
    </div>);
}
